import React from 'react'
import PropTypes from 'prop-types'
import { CloseIcon } from '@ow/icons'
import { StyledHeader, StyledTitle, StyleIcon } from './styled/content'
import RenderIf from '../render-if'

export default function Header({ title, showCloseButton, close }) {
  if (typeof title === 'string') {
    return (
      <StyledHeader className="dark:text-white dark:border-b dark:border-darkTheme-800 dark:border-solid">
        <StyledTitle className="dark:text-white">{title}</StyledTitle>
        <RenderIf isTrue={showCloseButton}>
          <StyleIcon onClick={close}>
            <CloseIcon width={16} height={16} fill="currentColor" />
          </StyleIcon>
        </RenderIf>
      </StyledHeader>
    )
  }
  return title
}

Header.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  showCloseButton: PropTypes.bool,
  close: PropTypes.func,
}
Header.defaultProps = {
  title: undefined,
  showCloseButton: undefined,
  close: undefined,
}
